<script setup lang="ts">
  import { computed } from 'vue'
  import { useRoute } from 'vue-router'
  import { useUpdateRoute } from '@/functions'

  defineProps<{
    label?: string,
    activeLabel?: string,
    inactiveLabel?: string,
  }>()

  const route = useRoute()
  const { updateRoute } = useUpdateRoute()

  const selectedStatus = computed({
    set: (status?: string) => updateRoute({ aktif: status }),
    get: () => route.query.aktif as string | undefined,
  })
</script>

<template>
  <app-select
    v-model="selectedStatus"
    :label="label ?? 'Status'">
    <option :value="undefined">
      Semua
    </option>
    <option value="1">
      {{ activeLabel ?? 'Aktif' }}
    </option>
    <option value="0">
      {{ inactiveLabel ?? 'Batal' }}
    </option>
  </app-select>
</template>
